import React from 'react';
import { bool, string, func } from 'prop-types';
import cx from 'classnames';
import style from './ReadIndicator.module.scss';

const ReadIndicator = ({ seen, updateRead, notifId }) => {
  return (
    <button
      type="button"
      className={cx(style.readIndicator, seen && style.seen)}
      onClick={e => updateRead(notifId, !seen, e)}
      aria-label={seen ? 'Mark as unread' : 'Mark as read'}
    />
  );
};

export default ReadIndicator;

ReadIndicator.propTypes = {
  seen: bool.isRequired,
  notifId: string.isRequired,
  updateRead: func.isRequired,
};
